package foatto.core.util

import kotlin.math.abs
import kotlin.random.Random

fun getRandomInt(): Int = abs(Random.nextInt())
fun getRandomLong(): Long = abs(Random.nextLong())

